import { render } from "./UIButton.vue?vue&type=template&id=8e9af29c&scoped=true"
import script from "./UIButton.vue?vue&type=script&lang=ts"
export * from "./UIButton.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-8e9af29c"

export default script